import React from 'react';
import { CardSectionElement } from './card-section.types';
import { BenefitsCard } from './cards/benefits-card';
import { FeatureCard } from './cards/feature-card';
import { HighlightCard } from './cards/highlight-card';
import { IconCard } from './cards/icon-card';

interface CardItemProps {
  card: CardSectionElement;
  cardType?: string;
  className?: string;
  /** Fully-built data-track-id for this card's link (e.g. "card-section-147-card-2"). */
  trackId?: string;
}

export function CardItem({ card, cardType, className, trackId }: CardItemProps) {
  switch (cardType) {
    case 'benefitsCard':
      return <BenefitsCard card={card} trackId={trackId} />;
    case 'highlightsCard':
      return <HighlightCard card={card} trackId={trackId} />;
    case 'featuresCards':
      return <FeatureCard card={card} className={className} />;
    case 'iconCard':
      return <IconCard card={card} className={className} trackId={trackId} />;
    default:
      return <BenefitsCard card={card} trackId={trackId} />;
  }
}
